import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AppNavigate from '../../components/reusable/app-navigate/AppNavigate';
import { Paths } from '../../shared/paths';
import BugReport from './bug-report/BugReport';
import BugReports from './bug-reports/BugReports';
import NewBugReport from './new-bug-report/NewBugReport';

export default function BugReportRouter() {
  return (
    <Routes>
      <Route index element={<BugReports />} />
      <Route path={Paths.bugReports.new} element={<NewBugReport />} />
      <Route path={'/:reportId'} element={<BugReport />} />
      <Route
        path={'*'}
        element={<AppNavigate to={Paths.bugReports.root} replace />}
      />
    </Routes>
  );
}
